"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYSET_PAGINATION_VER = exports.KeysetPaginationPageAction = void 0;
// Warning! Those are moved to @bringg/types/keyset_pagination
// and potentially will be removed from here
var KeysetPaginationPageAction;
(function (KeysetPaginationPageAction) {
    KeysetPaginationPageAction["NEXT"] = "next";
    KeysetPaginationPageAction["NEXT_ONLY"] = "next_only";
    KeysetPaginationPageAction["PREVIOUS"] = "previous";
})(KeysetPaginationPageAction = exports.KeysetPaginationPageAction || (exports.KeysetPaginationPageAction = {}));
exports.KEYSET_PAGINATION_VER = 2;
//# sourceMappingURL=keyset-pagination.consts.js.map